var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPastry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "fackvogusa",
    d: "M0 0L22.5 0 22.5 22.5 0 22.5z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "7tvaeh6wyb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fackvogusa"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#4A8254",
    d: "M22.5 11.25c0 6.214-5.036 11.25-11.25 11.25S0 17.464 0 11.25 5.036 0 11.25 0 22.5 5.036 22.5 11.25",
    mask: "url(#7tvaeh6wyb)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#70C494",
    d: "M13.9 19.97c-.507-.016-1.01.09-1.469.311-.928.45-2.018.413-2.915-.096-.441-.252-.938-.391-1.445-.408-1.03-.035-1.979-.573-2.536-1.44-.274-.428-.649-.783-1.09-1.034-.897-.51-1.486-1.426-1.576-2.454-.045-.506-.211-.994-.486-1.421-.558-.868-.653-1.954-.255-2.905.196-.47.275-.979.23-1.484-.09-1.028.33-2.033 1.125-2.691.39-.324.698-.738.894-1.207.398-.952 1.237-1.647 2.246-1.86.497-.106.962-.33 1.352-.654.795-.658 1.861-.884 2.854-.603.489.138 1.004.155 1.501.05 1.01-.214 2.059.082 2.807.792.368.349.817.603 1.306.741.992.28 1.784 1.03 2.117 2.006.165.48.443.915.812 1.264.749.709 1.101 1.74.943 2.76-.078.501-.033 1.015.131 1.496.333.976.166 2.053-.448 2.882-.302.408-.501.884-.578 1.386-.159 1.019-.808 1.895-1.737 2.343-.457.22-.854.55-1.156.958-.614.829-1.596 1.303-2.626 1.269"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCF040",
    d: "M11.324 7.92l.532 2.493c.014.067.067.12.135.134l2.492.532c.184.04.184.302 0 .342l-2.492.532c-.068.014-.121.067-.135.134l-.532 2.493c-.04.184-.303.184-.342 0l-.532-2.493c-.015-.067-.067-.12-.134-.134l-2.492-.532c-.185-.04-.185-.302 0-.342l2.492-.532c.067-.014.12-.067.134-.134l.532-2.493c.04-.184.302-.184.342 0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPastry);
export default __webpack_public_path__ + "static/media/pastry.d26613ce01467f47494085b6c088c83a.svg";
export { ForwardRef as ReactComponent };